import { Controls } from './controls'
import { Description } from './description'
import { Error } from './error'
import { Legend } from './legend'
import { Root } from './root'

export const GroupedField = {
  Root,
  Legend,
  Controls,
  Description,
  Error,
} as const
